import React from 'react';

function StudyPlanGenerator({ plan, onEdit }) {
  if (!plan) return null;

  return (
    <div className="study-plan-generator">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h6 className="font-weight-bold mb-0">Study Plan Details</h6>
          <small className="text-muted">Subject: {plan.subject}</small>
        </div>
        {onEdit && (
          <button 
            className="btn btn-sm btn-outline-primary"
            onClick={onEdit}
          >
            <i className="fas fa-edit me-1"></i>Edit
          </button>
        )}
      </div>
      
      <div className="row">
        <div className="col-md-6">
          <div className="card mb-3">
            <div className="card-body">
              <h6 className="card-title">Schedule</h6>
              {plan.planData?.weeklySchedule && plan.planData.weeklySchedule.length > 0 ? (
                <ul className="list-unstyled mb-0">
                  {plan.planData.weeklySchedule.slice(0, 3).map((day, index) => (
                    <li key={index} className="mb-1">
                      <i className="fas fa-calendar-day me-2 text-muted"></i>
                      <strong>{day.day}:</strong> {day.duration} - {day.activity}
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-muted mb-0">No schedule defined</p>
              )}
            </div>
          </div>
        </div>
        
        <div className="col-md-6">
          <div className="card mb-3">
            <div className="card-body">
              <h6 className="card-title">Progress</h6>
              <div className="text-center">
                <div className="display-4 text-primary">
                  {plan.progress || 0}%
                </div>
                <p className="text-muted mb-0">Completion</p>
              </div>
              <div className="progress mt-3" style={{height: '6px'}}>
                <div 
                  className="progress-bar bg-success"
                  style={{width: `${plan.progress || 0}%`}}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {plan.planData?.resources && plan.planData.resources.length > 0 && (
        <div className="card">
          <div className="card-body">
            <h6 className="card-title">Learning Resources</h6>
            <div className="row">
              {plan.planData.resources.slice(0, 3).map((resource, index) => (
                <div key={index} className="col-md-4 mb-2">
                  <div className="card border">
                    <div className="card-body p-2">
                      <small className="text-muted d-block">{resource.type}</small>
                      <small className="font-weight-bold">{resource.name}</small>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default StudyPlanGenerator;